import { defineComponent as d, ref as f, openBlock as t, createElementBlock as s, normalizeClass as c, renderSlot as o, createCommentVNode as p } from "vue";
const m = ["disabled"], v = { key: 0 }, y = /* @__PURE__ */ d({
  __name: "v-button",
  props: {
    color: { default: "primary" },
    variant: { default: "filled" },
    size: { default: "md" },
    disabled: { type: Boolean },
    square: { type: Boolean },
    action: {},
    value: {}
  },
  emits: ["click"],
  setup(n, { emit: i }) {
    const a = n, l = f(!1), r = i;
    function u(e) {
      a.disabled || l.value || (a.action ? (l.value = !0, a.action(e, a.value).finally(() => {
        l.value = !1;
      })) : r("click", e, a.value));
    }
    return (e, b) => (t(), s("button", {
      onClick: u,
      disabled: e.disabled || l.value,
      class: c(["v-button", [e.variant, e.color, e.size, e.disabled, { square: e.square }]]),
      type: "button"
    }, [
      o(e.$slots, "prefix"),
      e.$slots.default ? (t(), s("span", v, [
        o(e.$slots, "default")
      ])) : p("", !0),
      o(e.$slots, "suffix")
    ], 10, m));
  }
});
export {
  y as default
};
